export const API_ORIGIN = process.env.REACT_APP_API_ORIGIN;
export const MEDIA_ORIGIN = process.env.REACT_APP_MEDIA_ORIGIN;
